import ApiService from "./shared/ApiService2";

export default {
  getUsuario: async () => ApiService.get("/api/usuario/me")
};
